<div class="vc-period-selector">
  <!-- Period label (clickable to open date picker) -->
  <button
    class="vc-period-selector__label"
    (click)="datePicker.toggle($event)"
    type="button"
  >
    <i class="fas fa-calendar-alt vc-period-selector__icon"></i>
    <span class="vc-period-selector__text">{{ this.title | titlecase }}</span>
    <i class="fas fa-chevron-down vc-period-selector__chevron"></i>
  </button>

  <button class="vc-period-selector__today" type="button" (click)="goToToday()">
    {{ "CALENDAR.GO_TO_TODAY" | translate }}
  </button>

  <!-- Date picker popup -->
  <p-popover #datePicker styleClass="vc-date-picker-popover">
    <div class="vc-date-picker">
      <p-datepicker
        [(ngModel)]="selectedDate"
        [inline]="true"
        [showButtonBar]="true"
        [todayButtonStyleClass]="'p-button-text'"
        [clearButtonStyleClass]="'p-button-text'"
        (onSelect)="onDateSelect($event); datePicker.hide()"
        (onTodayClick)="goToToday(); datePicker.hide()"
      ></p-datepicker>
    </div>
  </p-popover>
</div>
